
import { supabase } from "@/integrations/supabase/client";

export interface UserPreferences {
  theme: 'light' | 'dark';
  auto_save_interval: number;
  keyboard_shortcuts_enabled: boolean;
  email_notifications: boolean;
  collaboration_notifications: boolean;
}

export const userPreferencesService = {
  async getPreferences(): Promise<UserPreferences | null> {
    try {
      // TODO: Re-enable when user_preferences table types are available
      // For now, return default preferences from localStorage
      const storedPrefs = localStorage.getItem('user_preferences');
      if (storedPrefs) {
        return JSON.parse(storedPrefs);
      }
      return null;
      
      // const { data: { user } } = await supabase.auth.getUser();
      // if (!user) return null;
      //
      // const { data, error } = await supabase
      //   .from('user_preferences')
      //   .select('*')
      //   .eq('user_id', user.id)
      //   .maybeSingle();
      //
      // if (error) throw error;
      // 
      // return data ? {
      //   theme: data.theme as 'light' | 'dark',
      //   auto_save_interval: data.auto_save_interval,
      //   keyboard_shortcuts_enabled: data.keyboard_shortcuts_enabled,
      //   email_notifications: data.email_notifications,
      //   collaboration_notifications: data.collaboration_notifications
      // } : null;
    } catch (error) {
      console.error('Failed to get user preferences:', error);
      return null;
    }
  },

  async updatePreferences(preferences: Partial<UserPreferences>): Promise<boolean> {
    try {
      // TODO: Re-enable when user_preferences table types are available
      // For now, store preferences in localStorage
      const existingPrefs = await this.getPreferences();
      const updatedPrefs = { ...existingPrefs, ...preferences };
      localStorage.setItem('user_preferences', JSON.stringify(updatedPrefs));
      return true;
      
      // const { data: { user } } = await supabase.auth.getUser();
      // if (!user) return false;
      //
      // const { error } = await supabase
      //   .from('user_preferences')
      //   .upsert({
      //     user_id: user.id,
      //     ...preferences,
      //     updated_at: new Date().toISOString()
      //   });
      //
      // if (error) throw error;
      // return true;
    } catch (error) {
      console.error('Failed to update user preferences:', error);
      return false;
    }
  }
};
